export enum ZenityEntityActionResultCode {
  success = 'success',
  failure = 'failure',
  noEffect = 'noEffect',
}

export interface ZenityEntityActionOutputs {
  resultCode: ZenityEntityActionResultCode;
  title: string;
  description: string | null;
}

export interface ZenityEntityActionInputs {}
